module.exports = __webpack_public_path__ + "img/norway-skin-connective-and-musculoskeletal-diseases-female.65968be8.png";